<!-- Menu Lateral -->
<div class="br-menu" id="main-navigation" [class.open]="isMenuOpen">
   <div class="menu-container">
      <div class="menu-panel">
         <div class="menu-header">
            <div class="menu-title">
               <img src="../../../assets/images/govbr.png" alt="logo" /><span
                  >CNCST</span
               >
            </div>
            <div class="menu-close">
               <button
                  class="br-button circle"
                  type="button"
                  aria-label="Fechar o menu"
                  (click)="closeMenu()"
               >
                  <i class="fas fa-times" aria-hidden="true"></i>
               </button>
            </div>
         </div>
         <nav class="menu-body">
            <a class="menu-item divider" (click)="linkPrincipal()"
               ><span class="content">Página Inicial</span></a
            >
            <a class="menu-item divider" (click)="linkApresentacao()"
               ><span class="content">Apresentação</span></a
            >
            <a class="menu-item divider" (click)="linkLegislacao()"
               ><span class="content">Legislação</span></a
            >
            <a class="menu-item divider" (click)="linkFAQ()"
               ><span class="content">Perguntas Frequentes</span></a
            >
            <a class="menu-item divider" (click)="linkExpediente()"
               ><span class="content">Expediente</span></a
            >

            <!-- Submenu -->

            <div class="menu-folder">
               <!-- Menu Encontre um Curso -->
               <a
                  class="menu-item has-submenu"
                  href="javascript:void(0)"
                  (click)="toggleMenu('cursos')"
               >
                  <span class="content">Encontre um Curso</span>
                  <span class="support"><i class="fas fa-angle-down"></i></span>
               </a>
               <ul id="cursos" [ngClass]="{ active: activeMenu === 'cursos' }">
                  <li>
                     <a class="menu-item" (click)="linkCursos()"
                        >Todos os Cursos</a
                     >
                  </li>
                  <li>
                     <a class="menu-item" (click)="linkCursoEixo()"
                        >Cursos por Eixo Tecnológico</a
                     >
                  </li>
                  <li>
                     <a class="menu-item" (click)="linkCursosConvergentes()"
                        >Tabela de Convergência</a
                     >
                  </li>
                  <li>
                     <a class="menu-item" (click)="linkCursosSubmissao()"
                        >Tabela de Submissão</a
                     >
                  </li>
               </ul>
               <!-- Menu Downloads -->
               <a
                  class="menu-item has-submenu"
                  href="javascript:void(0)"
                  (click)="toggleMenu('downloads')"
               >
                  <span class="content">Downloads</span>
                  <span class="support"><i class="fas fa-angle-down"></i></span>
               </a>
               <ul
                  id="downloads"
                  [ngClass]="{ active: activeMenu === 'downloads' }"
               >
                  <li>
                     <a
                        class="menu-item"
                        target="_blank"
                        rel="noreferrer"
                        href="{{ linkCatalogoPdf }}"
                        >Catálogo em PDF</a
                     >
                  </li>
                  <li>
                     <a class="menu-item" (click)="downloadCsvCatalogoCncst()">
                        Catálogo em CSV
                     </a>
                  </li>
                  <li>
                     <a
                        class="menu-item"
                        target="_blank"
                        rel="noreferrer"
                        href="{{ linkDadosAtualizadosPdf }}"
                     >
                        Registro de Alterações no Portal
                     </a>
                  </li>
               </ul>
               <!-- Menu Canais de Comunicação -->
               <a
                  class="menu-item has-submenu"
                  href="javascript:void(0)"
                  (click)="toggleMenu('melhoria')"
               >
                  <span class="content">Ajude a Melhorar o Catálogo</span>
                  <span class="support"><i class="fas fa-angle-down"></i></span>
               </a>
               <ul
                  id="melhoria"
                  [ngClass]="{ active: activeMenu === 'melhoria' }"
               >
                  <li>
                     <a class="menu-item" (click)="linkSugestao()"
                        >Envie sua Sugestão de Melhoria</a
                     >
                  </li>
               </ul>
               <!-- Menu Canais de Comunicação -->
               <a
                  class="menu-item has-submenu"
                  href="javascript:void(0)"
                  (click)="toggleMenu('fale-conosco')"
               >
                  <span class="content">Canais de Comunicação</span>
                  <span class="support"><i class="fas fa-angle-down"></i></span>
               </a>
               <ul
                  id="fale-conosco"
                  [ngClass]="{ active: activeMenu === 'fale-conosco' }"
               >
                  <li>
                     <a
                        class="menu-item"
                        target="_blank"
                        rel="noopener"
                        href="https://www.gov.br/mec/pt-br/canais_atendimento/fale-conosco"
                        >Fale Conosco</a
                     >
                  </li>
               </ul>
               <!-- Menu Links Externos -->
               <a
                  class="menu-item has-submenu"
                  href="javascript:void(0)"
                  (click)="toggleMenu('links-externos')"
               >
                  <span class="content">Links Externos</span>
                  <span class="support"><i class="fas fa-angle-down"></i></span>
               </a>
               <ul
                  id="links-externos"
                  [ngClass]="{ active: activeMenu === 'links-externos' }"
               >
                  <li>
                     <a
                        class="menu-item"
                        target="_blank"
                        rel="noopener"
                        href="http://cnct.mec.gov.br/"
                        >Catálogo Nacional de Cursos Técnicos (CNCT)</a
                     >
                  </li>
                  <li>
                     <a
                        class="menu-item"
                        target="_blank"
                        rel="noopener"
                        href="http://www.mtecbo.gov.br/cbosite/pages/home.jsf"
                        >Classificação Brasileira de Ocupações (CBO)</a
                     >
                  </li>
               </ul>
            </div>

            <!-- /Submenu -->
         </nav>
         <div class="menu-footer">
            <div class="menu-logos">
               <a
                  href="http://www.gov.br/acessoainformacao/"
                  target="_blank"
                  rel="noopener"
               >
                  <img
                     class="ml-4"
                     src="../../../assets/images/acesso-informacao-black.png"
                     alt="Acesso à Informação"
               /></a>
               <a
                  href="https://www.gov.br/mec/pt-br"
                  target="_blank"
                  rel="noopener"
               >
                  <img
                     class="ml-4"
                     src="../../../assets/images/mec.png"
                     alt="Ministério da Educação"
               /></a>
            </div>

            <div class="menu-links">
               <a
                  href="https://www.gov.br/pt-br/apps/@@galeria-de-aplicativos"
                  target="_blank"
                  rel="noopener"
                  ><span class="mr-1">Galeria de Aplicativos</span
                  ><i
                     class="fas fa-external-link-square-alt"
                     aria-hidden="true"
                  ></i
               ></a>
               <a
                  href="https://www.gov.br/pt-br/participacao-social"
                  target="_blank"
                  rel="noopener"
                  ><span class="mr-1">Participe</span
                  ><i
                     class="fas fa-external-link-square-alt"
                     aria-hidden="true"
                  ></i
               ></a>
            </div>

            <div class="social-network">
               <div class="social-network-title">Redes Sociais</div>
               <div class="d-flex">
                  <a
                     class="br-button circle"
                     href="https://twitter.com/min_educacao"
                     aria-label="Compartilhar por Twitter"
                     target="_blank"
                     rel="noopener"
                     ><i class="fab fa-x-twitter" aria-hidden="true"></i
                  ></a>
                  <a
                     class="br-button circle"
                     href="https://www.youtube.com/user/ministeriodaeducacao"
                     aria-label="Compartilhar por YouTube"
                     target="_blank"
                     rel="noopener"
                     ><i class="fab fa-youtube" aria-hidden="true"></i
                  ></a>
                  <a
                     class="br-button circle"
                     href="https://www.facebook.com/ministeriodaeducacao/"
                     aria-label="Compartilhar por Facebook"
                     target="_blank"
                     rel="noopener"
                     ><i class="fab fa-facebook-f" aria-hidden="true"></i
                  ></a>
                  <a
                     class="br-button circle"
                     href="https://www.instagram.com/mineducacao/"
                     aria-label="Compartilhar por Instagram"
                     target="_blank"
                     rel="noopener"
                     ><i class="fab fa-instagram" aria-hidden="true"></i
                  ></a>
               </div>
            </div>

            <div class="menu-info">
               <div class="text-center text-down-01">
                  Todo o conteúdo deste site está publicado sob a licença
                  <strong>Creative Commons Atribuição-SemDerivações 3.0</strong>
               </div>
            </div>
         </div>
      </div>
      <div class="menu-scrim" data-dismiss="menu" tabindex="0"></div>
   </div>
</div>
<!-- /Menu Lateral -->

<div class="menu-scrim" (click)="closeMenu()"></div>
